import {Injectable} from "@angular/core";
import {Storage} from "@ionic/storage";
import {GDAuthInterface} from "../../model/gd-auth";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {NestAuthProvider} from "../../shared/nestjs/nest-auth";
import {saveAs} from 'file-saver';

@Injectable()
export class AttendanceSummaryBloc {
  constructor(
    private storage: Storage,
    private http: HttpClient,
    private nestAuthProvider: NestAuthProvider,
  ) {
  }

  async getSFGoAuth(): Promise<GDAuthInterface> {
    return JSON.parse(await this.storage.get('SFGoAuth'));
  }

  async makeFileRequest(url: string, params: any, valueRadio: string): Promise<void> {
    return new Promise<void>(resolve => {
      const headers = new HttpHeaders()
        .set('Authorization', this.nestAuthProvider.getAccessToken());
      this.http.post(`${url}`, params, {
        responseType: "blob",
        headers: headers
      }).subscribe((response: any) => {
        console.log(response);
        if (valueRadio == 'excel') {
          saveAs(response, "attendancesummary.xlsx");
          resolve();
        } else if (valueRadio == 'pdf') {
          saveAs(response, "attendancesummary.pdf");
          resolve();
        }
      }, () => {
        resolve();
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/bloc/report/attendance-summary.bloc.ts